import type { QueryClient, QueryKey } from "@tanstack/react-query";

export function getLastGoodQueryData<T>(
  queryClient: QueryClient,
  logicalQueryKey: QueryKey,
): T | undefined {
  let newestData: T | undefined;
  let newestUpdatedAt = 0;
  for (const query of queryClient
    .getQueryCache()
    .findAll({ queryKey: logicalQueryKey })) {
    if (
      query.queryKey.length !== logicalQueryKey.length + 1 ||
      query.state.data === undefined ||
      query.state.dataUpdatedAt < newestUpdatedAt
    ) {
      continue;
    }
    newestData = query.state.data as T;
    newestUpdatedAt = query.state.dataUpdatedAt;
  }
  return newestData;
}
